<script lang="ts" setup>
import { vElementVisibility } from '@vueuse/components'

const props = defineProps({
  levelToOpen: {
    default: 2,
    type: Number,
  },
  method: {
    default: 'GET',
    type: String as PropType<ApiEndpointMethodMethod>,
  },
  params: {
    default: () => ({}),
    type: Object as PropType<Record<string, any>>,
  },
  path: {
    default: '',
    type: String,
  },
})

const { version } = useApiDoc()
const config = useRuntimeConfig()

const { data: response, execute, status } = useAsyncData(
  `api:playground:${props.path || 'no-path-provided'}`,
  async () => {
    try {
      if (props.path) {
        const urlPath = props.path.split('?')[0]
        const finalUrl = new URL(`${config.public.apis.public}/${version.value}${urlPath}`)

        const options: RequestInit = {
          headers: { 'Content-Type': 'application/json' },
          method: props.method,
        }

        // Add query params for requests
        if (props.params) {
          if (props.method === 'GET') {
            Object.keys(props.params).forEach(key =>
              finalUrl.searchParams.append(key, props.params[key]),
            )
          }
          else if (props.method === 'POST') {
            options.body = JSON.stringify(props.params)
          }
        }

        const response = await fetch(finalUrl, options)

        return response.json()
      }
    }
    catch (error) {
      console.error(error)
    }

    return null
  },
  { immediate: false },
)

async function onVisibilityChange(visibility: boolean) {
  if (visibility && !response.value) {
    await execute()
  }
}
</script>

<template>
  <div
    v-element-visibility="onVisibilityChange"
    class="flex h-full flex-col gap-2"
  >
    <ApiEndpoint
      v-if="path"
      class="flex-initial"
      has-borders
      has-copy
      :method="method"
      :path="path"
    />

    <div class="min-h-0 flex-1">
      <ApiResponse
        v-if="response || status === 'pending'"
        :has-header="false"
        :level-to-open="levelToOpen"
        :loading="status === 'pending'"
        :response="response"
      />
    </div>
  </div>
</template>
